import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, offerIncludes, offerRows } from '../data/spremna';
import { PRODUCT_IMAGE } from '../data/assets';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-223" data-mp="1mpd5s4kh617g">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-224" data-mp="1hqs5641b9fih">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-225" data-mp="u0xspnkwlsyr">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-226" data-mp="p0jwd2so07gk">
            Цео пакет <em className="text-red-300" style={{
            hyphens: 'manual'
          }} data-id="element-227" data-mp="13y2h7u2820iq">КОШАРКА СПРЕМНА™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-228" data-mp="ywwqg1s4gnbu">
            Цела сезона тренинга – спремна. Уђите у салу са планом.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-229" data-mp="2add6nxbi37zr" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-230" data-mp="pj5tkl34eccf">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-231" data-mp="ul4y3yaljfay">Цео пакет садржи</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-232" data-mp="zgagwo8pcdut">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-233" data-mp="13hnmcx7vuf17">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-234" data-mp="6vakvfmd7oq6">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-235" data-mp="bt2eqf6klkx0" />
                </span>
                <span data-id="element-236" data-mp="fskz99uhbtzb">
                  <span className="block font-medium leading-snug" data-id="element-237" data-mp="klnsthz9b3fi">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-238" data-mp="3k8m4h4818l7b">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-239" data-mp="3o8edtj592vdq">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-240" data-mp="qgxl4e3dntu5">Уводна цена <s className="ml-1 text-slate-900/50" data-id="element-241" data-mp="qetg1stqsosa">{PRICE_BEFORE}</s></p>
            <p className="whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-242" data-mp="1550qpmdid3if">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-243" data-mp="cg3adosuxgsb">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="7j3c40291ibr" />
            Једнократна уплата. Без претплате.
          </p>

          <CtaButton label="Преузмите цео пакет" className="mt-8 w-full" data-id="element-245" data-mp="lfgh49pljr9c" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-246" data-mp="heegppjy195s">
            {offerIncludes.map(item => <li key={item} data-id="element-247" data-mp="1wykmodvqghgb">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}